import { createSlice } from '@reduxjs/toolkit'

export const DirectoryDetailsSlice = createSlice({
  name: 'directory',
  initialState: {
    directoryLookUp: {},
    directoryEligibility: true,
    directoryAccessToken: null,
    directoryPaymentMethods: [],
    otpLoader: false,
    savedPaymentsClose: false,
  },
  reducers: {
    setDirectoryLookUp: (state, action) => {
      state.directoryLookUp = action.payload
    },
    setDirectoryEligibility: (state, action) => {
      state.directoryEligibility = action.payload
    },
    setDirectoryAccessToken : (state, action) => {
      state.directoryAccessToken = action.payload
    },
    setDirectoryPaymentMethods : (state, action) => {
      state.directoryPaymentMethods = action.payload
    },
    setOtpLoader: (state, action) => {
      state.otpLoader = action.payload
    },
    setSavedPaymentsClose: (state, action) => {
      state.savedPaymentsClose = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setDirectoryLookUp, setDirectoryEligibility, setDirectoryAccessToken,
  setDirectoryPaymentMethods, setOtpLoader, setSavedPaymentsClose,
} = DirectoryDetailsSlice.actions

export default DirectoryDetailsSlice.reducer